import styled from "styled-components";
import {IconTitleTextTooltipIconBox} from "../../icon-title-text/boxes/icon.box";

export const IconContainerBox = styled(IconTitleTextTooltipIconBox)`
    padding: 8px;
    background-color: black;
    border: 1px solid black;
    border-radius: 20%;
    height: 50px;
    width: 52px;
 `;
